import { CalendarDays, Globe, MapPin, MessageSquareText } from "lucide-react";
import CurrentStatus from "./components/CurrentStatus";

const descriptionTypes = [
  {
    label: "Industry",
    value: "Finance",
  },
  {
    label: "Job Type",
    value: "Full Time",
  },
  {
    label: "Experience Level",
    value: "Mid Level (2-5 years)",
  },
  {
    label: "Qualification",
    value: "Bachelor's degree in Computer Science or related field",
  },
  {
    label: "Availability",
    value: "Immediate",
  },
  {
    label: "Workplace Type",
    value: "Hybrid",
  },
  {
    label: "Benefits",
    value:
      "Private Healthcare, Pension, 25 days holiday + bank holidays, Flexible working",
  },
];

const keyResponsibilities = [
  "Develop and maintain React applications.",
  "Work with designers to implement UI/UX best practices.",
  "Collaborate with backend developers to integrate APIs.",
  "Write clean, scalable and testable code.",
  "Participate in code reviews and team discussions.",
];

const JobDetails = () => {
  return (
    <div className="flex gap-3">
      {/* Column 1 */}
      <div className="flex flex-col gap-3">
        {/* Job Description */}
        <div className="flex flex-col p-4 border rounded-md gap-2">
          <span className="font-bold text-sm">Job Description</span>
          <span className="font-semibold text-xss text-light-black leading-5">
            We are looking for a skilled Mid level React Developer to join our
            growing engineering team. You will build high-quality web
            applications, collaborate with cross-functional teams and help
            deliver secure, scalable solutions.
          </span>

          {/* Description Types */}
          <div className="flex flex-col gap-3 border-t pt-5 mt-3 pl-20">
            {descriptionTypes?.map((descriptionType) => {
              return (
                <div className="grid grid-cols-[0.5fr_1.5fr]">
                  <span className="font-semibold text-xss text-light-black">
                    {descriptionType?.label}
                  </span>
                  <span className="font-semibold text-xss">
                    {descriptionType?.value}
                  </span>
                </div>
              );
            })}
          </div>

          {/* Key Responsibilities */}
          <div className="flex flex-col gap-3 mt-3 pl-20">
            <span className="font-bold text-xss">Key Responsibilites</span>
            <div className="flex flex-col gap-3">
              {keyResponsibilities?.map((keyResponsibility) => {
                return (
                  <span
                    key={keyResponsibility}
                    className="font-semibold text-xss text-light-black"
                  >
                    • &nbsp;{keyResponsibility}
                  </span>
                );
              })}
            </div>
          </div>
        </div>

        {/* Company Details */}
        <div className="flex p-4 border rounded-md gap-4">
          <div className="h-16 w-16 rounded-full bg-black shrink-0 flex items-center justify-center text-white font-bold text-4xl">
            A
          </div>
          <div className="flex flex-col gap-2">
            <span className="font-semibold text-sm">About CyberSecure Ltd</span>
            <span className="font-semibold text-xss text-light-black leading-5">
              CyberSecure Ltd is a leading provider of cybersecurity solutions
              to financial institutions worldwide. Our mission is to protect
              businesses and their customers through innovative technology and
              expert teams.
            </span>

            <div className="flex gap-8 mt-2">
              <div className="flex gap-2">
                <CalendarDays size={14} />
                <div className="flex flex-col gap-0.5">
                  <span className="font-semibold text-xsss">Company Size</span>
                  <span className="font-semibold text-xsss text-light-black">
                    201-500 employees
                  </span>
                </div>
              </div>
              <div className="flex gap-2">
                <Globe size={14} />
                <div className="flex flex-col gap-0.5">
                  <span className="font-semibold text-xsss">Website</span>
                  <span className="font-semibold text-xsss text-light-black">
                    www.cybersecure.com
                  </span>
                </div>
              </div>
              <div className="flex gap-2">
                <MapPin size={14} />
                <div className="flex flex-col gap-0.5">
                  <span className="font-semibold text-xsss">Headquarters</span>
                  <span className="font-semibold text-xsss text-light-black">
                    London, UK
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="flex flex-col w-[30%] shrink-0 gap-3">
        <CurrentStatus />
        {/* Need help section */}
        <div className="flex items-center border bg-light-white-900 rounded-md p-3">
          <div className="flex flex-col gap-3">
            <span className="text-xss font-bold">Need help?</span>
            <span className="text-xsss font-semibold text-blue-900">
              If you have any question regarding your application, please
              contact the recruiter.
            </span>
            <button className="text-xss font-semibold rounded-md bg-white border w-max px-3 py-2">
              Contact Recruiter
            </button>
          </div>
          <div className="h-8 w-8 rounded-full flex items-center justify-center bg-gray-200 shrink-0">
            <MessageSquareText size={16} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default JobDetails;
